<cm-overlay>
  <cm-setup
    title="{{ 'SETUP_WELCOME_TITLE' | translate }}"
    subTitle="{{ 'SETUP_WELCOME_SUBTITLE' | translate }}"
    (okPressed)="onOk($event)"
  ></cm-setup>
</cm-overlay>
